import request from "@/utils/request";

export default function agentGetQrcodeUrlToGenerate(id) {
  return request.get(
    `/device/deviceQRCode/agent/getQrcodeUrlToGenerate?deviceId=${id}`
  );
}
